import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initGtm } from './utils/gtmBootstrap';
import App from './App';

initGtm();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

